import { motion } from "framer-motion";
import { journey } from "../data/site";

export default function Journey() {
    return (
        <section
            id="journey"
            className="relative bg-[#0b0b0b] py-24 md:py-32 px-6 md:px-10 overflow-hidden"
            data-testid="journey-section"
        >
            <div className="mx-auto max-w-[1440px]">
                <div className="flex items-center gap-6 mb-10">
                    <span className="w-16 h-px bg-[#C89B3C]" />
                    <span className="text-[10px] uppercase tracking-[0.4em] text-[#C89B3C]">
                        Chapter 10 — The Method
                    </span>
                </div>

                <div className="grid grid-cols-12 gap-6 items-end mb-16">
                    <motion.h2
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 0.9 }}
                        className="col-span-12 lg:col-span-8 font-display font-light text-white text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
                    >
                        The Construction <em className="text-[#E2C56D]">Journey.</em>
                    </motion.h2>
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 0.9, delay: 0.15 }}
                        className="col-span-12 lg:col-span-4 text-[#bebebe] text-base leading-relaxed font-light"
                    >
                        Seven exacting stages. One clear path from land to landmark.
                    </motion.div>
                </div>

                {/* Desktop horizontal timeline */}
                <div className="hidden md:block relative">
                    <div className="absolute left-0 right-0 top-[54px] h-px bg-[rgba(212,175,55,0.22)]" />
                    <motion.div
                        initial={{ scaleX: 0 }}
                        whileInView={{ scaleX: 1 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 2, ease: [0.2, 0.7, 0.2, 1] }}
                        style={{ transformOrigin: "left" }}
                        className="absolute left-0 top-[54px] h-px bg-[#C89B3C] w-full"
                    />

                    <div className="grid grid-cols-7 gap-2 md:gap-4">
                        {journey.map((step, i) => (
                            <motion.div
                                key={step}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-15%" }}
                                transition={{ duration: 0.6, delay: 0.15 + i * 0.1 }}
                                className="relative"
                                data-testid={`journey-step-${i}`}
                            >
                                <div className="text-[10px] uppercase tracking-[0.3em] text-[#C89B3C] h-10 flex items-end">
                                    Step {String(i + 1).padStart(2, "0")}
                                </div>
                                <div className="relative h-8 flex items-center">
                                    <div className="absolute left-0 w-4 h-4 rotate-45 border border-[#C89B3C] bg-[#0b0b0b]" />
                                </div>
                                <div className="mt-4 font-display text-base md:text-xl lg:text-2xl text-white leading-tight tracking-tight">
                                    {step}
                                </div>
                                <div className="mt-2 text-[10px] uppercase tracking-[0.3em] text-[#7a7a7a]">
                                    {i < journey.length - 1 ? "→ Next" : "Handover"}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* Mobile vertical timeline */}
                <div className="md:hidden relative pl-8">
                    <div className="absolute left-3 top-0 bottom-0 w-px bg-[rgba(212,175,55,0.35)]" />
                    <div className="space-y-8">
                        {journey.map((step, i) => (
                            <motion.div
                                key={step}
                                initial={{ opacity: 0, x: -12 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, margin: "-10%" }}
                                transition={{ duration: 0.6, delay: i * 0.08 }}
                                className="relative"
                                data-testid={`journey-step-m-${i}`}
                            >
                                <div className="absolute -left-[22px] top-1 w-3 h-3 rotate-45 border border-[#C89B3C] bg-[#0b0b0b]" />
                                <div className="text-[10px] uppercase tracking-[0.3em] text-[#C89B3C]">
                                    Step {String(i + 1).padStart(2, "0")}
                                </div>
                                <div className="mt-1 font-display text-2xl text-white leading-tight">
                                    {step}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>

                <div className="mt-14 flex items-center gap-4 text-[10px] uppercase tracking-[0.35em] text-[#7a7a7a]">
                    <span className="w-10 h-px bg-[#C89B3C]" />
                    Every step documented. Every stage inspected.
                </div>
            </div>
        </section>
    );
}
